import { Button } from '@tvg/fuse/button';
import { IconClose } from '@tvg/fuse/icon/all';
import { EUserAction } from 'client/config';
import { usePLPNavigate } from 'client/hooks/usePLPNavigate';
import { SEOAnchor } from 'client/pages/CheckboxGroup/SEOAnchor/SEOAnchor';
import { useDrawerState } from 'client/state/Drawer';
import { FacetType } from 'common/types/facet';
import React, { useCallback } from 'react';
import styles from './ChipList.module.css';

interface ChipProps {
  id: string;
  name: string;
  facetId: string;
  href: string;
  onMouseEnter?: React.MouseEventHandler<HTMLAnchorElement>;
  onFocus?: React.FocusEventHandler<HTMLAnchorElement>;
}

function Chip({ id, name, facetId, href, onFocus, onMouseEnter }: ChipProps) {
  const plpNavigate = usePLPNavigate();
  const toggleShowViewProducts = useDrawerState((s) => s.toggleShowViewProducts);

  const handleRemove = useCallback(
    (e: React.FormEvent<HTMLElement>) => {
      e.preventDefault();
      toggleShowViewProducts.on();
      plpNavigate({ facet: { id: facetId, option: id } }, EUserAction.FACET);
    },
    [facetId, id, plpNavigate, toggleShowViewProducts],
  );

  return (
    <li>
      <SEOAnchor href={href} className="forSEO" tabIndex={-1} onMouseEnter={onMouseEnter} onFocus={onFocus}>
        <Button
          className={styles.chipList__chip}
          icon={<IconClose />}
          iconRight
          onClick={handleRemove}
          data-value={`${id}_${name}`}
          data-testid="chip-button"
          aria-label={`${name} filter selected, click to remove`}
        >
          {facetId === FacetType.rating ? `Customer rating ${name}` : name}
        </Button>
      </SEOAnchor>
    </li>
  );
}

export default React.memo(Chip);
